import { render, staticRenderFns } from "./BookingDetailInfoBox.vue?vue&type=template&id=7ee8d85b&"
import script from "./BookingDetailInfoBox.vue?vue&type=script&lang=ts&"
export * from "./BookingDetailInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports